/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmModelsListClusterPrices } from "../../funcs/llmModelsListClusterPrices.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListClusterPricesRequest$inboundSchema,
};

export const tool$llmModelsListClusterPrices: ToolDefinition<typeof args> = {
  name: "llm-models-list-cluster-prices",
  description: `List cluster-default model prices

Without \`model\`, lists every model's current cluster-default price. With \`model\`, returns that model's full dated history.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmModelsListClusterPrices(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
